import React from "react";
import { useNavigate } from "react-router-dom";
import "./MainScreen.css";
import logo from "../assets/images/logo_cyber_112.png";

const MainScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <div className="main-box">
        <img src={logo} alt="Logo" className="logo" />
        <p>Protecting yourself online is not just about your computer, it's about your entire digital life.</p>
        
        <button className="main-button" onClick={() => navigate("/signup")}>Sign Up</button>
        <button className="main-button" onClick={() => navigate("/login")}>Log In</button>
       
      </div>
    </div>
  );
};

export default MainScreen;